export const primaryBlack = "#000000"
export const primaryRed = "#ff4100"
export const primaryBlue = "#096c93"
export const darkerBlue = "#005878"
export const button = "#ffffff"
export const newsEvents = "#ffffff"
